import React, { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Layout, Menu } from "antd";
import {
  CustomerServiceOutlined,
  LineChartOutlined,
  SettingOutlined,
  UnorderedListOutlined,
} from "@ant-design/icons";
import { useRoleChecker } from "@/hooks/UseRoleChecker";
import { roles } from "@/utils/constant";
import { useSelector } from "react-redux";
import { selectAuthCurrent } from "@/redux/auth/selectors";

const { Sider } = Layout;

function Navigation() {
  const [collapsed, setCollapsed] = useState(false);
  const { user } = useSelector(selectAuthCurrent);
  const isAdmin = useRoleChecker(roles.ADMIN, user?.role);
  const location = useLocation();
  const activeBar = location?.pathname?.split("/")[1];

  const defaultKeys = {
    appraisal: {
      key: "1",
    },
    insights: {
      key: "2",
    },
    settings: {
      key: "3",
    },
  };

  const items = [
    {
      key: "1",
      icon: <UnorderedListOutlined />,
      label: <NavLink to="/appraisal">Appraisals</NavLink>,
    },
  ];

  const adminItems = [
    {
      key: "1",
      icon: <UnorderedListOutlined />,
      label: <NavLink to="/appraisal">Appraisals</NavLink>,
    },
    {
      key: "2",
      icon: <LineChartOutlined />,
      label: <NavLink to="/insights">Insights</NavLink>,
    },
    {
      key: "3",
      icon: <SettingOutlined />,
      label: <NavLink to="/settings">Settings</NavLink>,
    },
  ];

  const onCollapse = () => {
    setCollapsed(!collapsed);
  };
  return (
    <Sider
      collapsed={collapsed}
      onCollapse={onCollapse}
      style={{
        zIndex: 1000,
        position: "sticky",
        top: "0px",
        left: "0px",
        height: "100vh",
      }}
    >
      <img src="/assets/images/logo.png" alt="png logo" className="logo" />
      <Menu
        defaultSelectedKeys={[`${defaultKeys[activeBar]?.key}`]}
        mode="inline"
        items={isAdmin ? adminItems : items}
      />
    </Sider>
  );
}
export default Navigation;
